<script setup lang="ts">
import { inject, reactive, Ref } from 'vue';
import { DateTime } from 'luxon';
import { useVoucherStore } from '@/store/VoucherStore';
import Button from 'primevue/button';
import Fluid from 'primevue/fluid';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';

const dialogRef = inject('dialogRef') as Ref;
const id = dialogRef.value.data.quoteId;
const isSave = dialogRef?.value.options.emits.isSave;

const voucherStore = useVoucherStore();

const form = reactive({
  bookingNumber: '',
  value: undefined,
  name: '',
  id: id
});
const submit = async () => {
  const payload = {
    redeemBookingNo: form.bookingNumber,
    amount: form.value,
    name: form.name,
    id: id,
    redeemDate: formatDate(new Date())
  };
  await voucherStore.handleRedeem(payload, id);
  isSave();
};
const formatDate = (date) => {
  return date ? DateTime.fromJSDate(new Date(date)).toFormat('yyyy-LL-dd') : '';
};
</script>
<template>
  <div>
    <Fluid>
      <div class="field grid">
        <div class="col">
          <label for="booking-number">{{ $t('voucher.apply-to-booking') }}</label>
          <InputText id="booking-number" v-model="form.bookingNumber" type="text" />
        </div>
        <div class="col">
          <label for="booking-amount">{{ $t('voucher.voucher-amount') }}</label>
          <InputNumber inputId="booking-amount" v-model="form.value" :minFractionDigits="2" />
        </div>
      </div>
    </Fluid>
  </div>
  <div class="mt-5">
    <Fluid>
      <div class="field grid">
        <div class="col">
          <label for="booking-name">{{ $t('voucher.client-name') }}</label>
          <InputText id="booking-name" v-model="form.name" type="text" />
        </div>
      </div>
    </Fluid>
  </div>
  <div class="btn-center">
    <Button :disabled="!form.bookingNumber || !form.value || !form.name" :label="$t('voucher.submit')" @click="submit()" />
  </div>
</template>
<style lang="scss" scoped>
.btn-center {
  display: flex;
  justify-content: center;
}
</style>
